<template>
  <modal
    :ignoreBackdropClick="true"
    :show.sync="shown"
    headerClasses="justify-content-center"
    class="modal-options"
    :showClose="false"
    bodyClasses="center"
    v-if="
      ItemsNotAvailable.length ||
        ItemsWithDiffPrice.length ||
        ItemsNotAvailableByType.length ||
        ItemOptionsValuesAvailibility.length ||
        ItemsNotAvailableForToday.length ||
        ItemsNotAvailableByTime.length
    "
    modalClasses="modal-dialog-centered modal-dialog-scrollable"
  >
    <h4 slot="header" class="title title-up">{{ $t('message.confirm_re_ordering_title') }}</h4>
    <template>
      <i class="icon-style icon-color k-icon-menu"></i>

      <div v-if="ItemsNotAvailable.length">
        <p class="info-message">
          {{ $t("message.confirm_re_ordering_message") }}
        </p>
        <p
          class="item-name"
          v-for="(item, index) in ItemsNotAvailable"
          :key="index"
        >
          {{ item.menuItem.name }}
        </p>
      </div>

      <div v-if="ItemsNotAvailableForToday.length">
        <p class="info-message">
          {{ $t("message.items_not_available_for_today") }}
        </p>
        <p
          class="item-name"
          v-for="(item, index) in ItemsNotAvailableForToday"
          :key="index"
        >
          {{ item.menuItem.name }}
        </p>
      </div>

      <div v-if="ItemsNotAvailableByTime.length">
        <p class="info-message">
          {{ $t("message.items_not_available_for_hour") }}
        </p>
        <p
          class="item-name"
          v-for="(item, index) in ItemsNotAvailableByTime"
          :key="index"
        >
          {{ item.menuItem.name }}
        </p>
      </div>

      <div v-if="ItemsNotAvailableByType.length">
        <p class="confirmation-message">
          {{ $t("message.items_not_available_for") }}
          <span>{{ getHelpers.getOrderTypeText(orderType) }}</span>
        </p>
        <p
          class="item-name"
          v-for="(item, index) in ItemsNotAvailableByType"
          :key="index"
        >
          {{ item.menuItem.name }}
        </p>
      </div>

      <div v-if="ItemOptionsValuesAvailibility.length">
        <p class="info-message">{{ $t("message.option_value_not_available") }}</p>
        <div
          v-for="(item, index) in ItemOptionsValuesAvailibility"
          :key="index"
        >
          <p class="item-name">
            {{ item.orderItem.menuItem.name }}
          </p>
          <div v-if="item.options.length">
            <ul class="options-list">
              <li v-for="(option, index) in item.options" :key="index">
                {{ option.name }}
              </li>
            </ul>
          </div>

          <div v-if="item.values.length">
            <ul class="options-list">
              <li v-for="(optionValue, index) in item.values" :key="index">
                {{ `${optionValue.name}  => ${optionValue.values[0].name} ` }}
              </li>
            </ul>
          </div>
        </div>
        <p class="info-message">{{ $t("message.select_new_option") }}</p>
      </div>

      <div v-if="ItemsWithDiffPrice.length">
        <p class="info-message">{{ $t("message.items_in_cart_price_changed") }}</p>
        <div
          class="grid-items"
          v-for="(item, index) in ItemsWithDiffPrice"
          :key="index"
        >
          <div class="grid-item-name">
            <p class="item-name">{{ item.menuItem.name }}</p>
          </div>
          <div class="grid-item-price-status">
            <i class="icon-color" :class="getPriceIcon(item)"></i>
          </div>
          <div class="grid-item-price">
            <p class="item-name">
              {{ getHelpers.getMenuItemPrice(item.menuItem, orderType) }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <p class="confirmation-message">{{ $t("message.continue_re_ordering") }}</p>
      </div>
    </template>
    <template slot="footer">
      <n-button type="success" @click.native="confirmReOredering">
        {{ $t("button.re_order") }}
      </n-button>
      <n-button type="default" @click.native="closeModal">{{ $t("button.cancel") }}</n-button>
    </template>
  </modal>
</template>
<script>
import { Button, Modal } from "@/components";
import { helpers } from "@/utilities";
export default {
  components: {
    [Button.name]: Button,
    Modal,
  },
  props: {
    ItemsNotAvailable: Array,
    ItemsWithDiffPrice: Array,
    ItemsNotAvailableByType: Array,
    orderType: [String, Number],
    ItemOptionsValuesAvailibility: Array,
    ItemsNotAvailableForToday: Array,
    ItemsNotAvailableByTime: Array,
  },
  data() {
    return {
      shown: false,
      getHelpers: helpers,
    };
  },
  methods: {
    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
    },
    confirmReOredering() {
      this.$root.$emit("CONTINUE_REORDER", true);
    },

    getPriceIcon(item) {
      let new_price = parseFloat(
        helpers.getOriginItemTotal(item, this.orderType)
      );
      let old_price = parseFloat(helpers.getReOrderItemTotal(item));
      return new_price > old_price ? "k-icon-priceup" : "k-icon-pricedown";
    },
  },
};
</script>
<style scoped>
.icon-style {
  font-size: 5rem;
}
.text-style {
  font-size: 1.5rem;
  font-weight: 800;
}
p.info-message,
p.confirmation-message,
p.confirmation-message span {
  line-height: 1.6em;
  font-weight: bold;
  font-size: 1.1em;
}
p.info-message{
  font-weight: normal;
}
p.confirmation-message span,
.icon-color {
  color: #ff6600;
}
p.item-name {
  line-height: 1.1em;
  font-size: 1.3em;
  font-weight: 600;
}
.options-list {
  text-align: left;
  font-size: 0.8rem;
  font-weight: 600;
}
.grid-items {
  display: grid;
  grid-template-columns: 70% 10% 20%;
}
.grid-item-name {
  grid-column: 1;
  text-align: start;
}
.grid-item-price-status {
  grid-column: 2;
}
.grid-item-price {
  grid-column: 3;
  text-align: end;
}
</style>
